import Popover from '@mui/material/Popover';
import { useState } from 'react';
import DocsIcon from '../../../../images/icons/docs.svg';
import LinearbLogo from '../../../../images/icons/linearb-logo.svg';
import CustomPopover from '../../Popover';
import { StyledLifebuoy } from './Lifebuoy.style';

const Lifebuoy = () => {
  const [docsAnchorEl, setDocsAnchorEl] = useState(null);

  const handleDocsOpen = event => {
    setDocsAnchorEl(event.currentTarget);
  };

  const handleDocsClose = () => {
    setDocsAnchorEl(null);
  };

  const docOpen = Boolean(docsAnchorEl);
  const docsId = open ? 'docs-popover' : undefined;

  return (
    <>
      <StyledLifebuoy onClick={handleDocsOpen} className='topbar-lifebuoy' />
      <Popover
        id={docsId}
        open={docOpen}
        anchorEl={docsAnchorEl}
        onClose={handleDocsClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <CustomPopover
          elements={[
            {
              icon: DocsIcon,
              title: 'Docs',
              content:
                'Learn how to make the most out of your automations, discover new automations, useful tips and use cases.',
              linkUrl: 'https://docs.gitstream.cm/',
              buttonText: 'See the documentation',
            },
            {
              icon: LinearbLogo,
              title: 'LinearB',
              content:
                'Check out the engineering metrics gitStream is improving!',
              linkUrl: 'https://app.linearb.io/',
              buttonText: 'See my LinearB dashboard',
            },
          ]}
        />
      </Popover>
    </>
  );
};

export default Lifebuoy;
